import { IAllergy } from 'common/interfaces/additionalInfo';
import axios from 'axios';

export default class AllergiesService {
  public createAllergy = (requestData: Omit<IAllergy, 'id'>): Promise<IAllergy> =>
    axios.post(`/api/v1/allergies`, requestData);
}
